// extracted by mini-css-extract-plugin
export default {"html":"payment-success_html__qjS78","body":"payment-success_body__Ho1n5","_success":"payment-success__success__MjtuU"};